import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {
  DeleteStatus,
  exportAsExcelFile,
  formatDataExport,
  formatFilter,
  getListPaymentMethod,
  GuestType,
  ItemMode, MasterDataStatus,
  PaymentMethod,
  SharedService
} from '../shared/shared.service';
import { ProxyDynamicService } from '../shared/service/proxy-dynamic.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import moment from 'moment/moment';
import { FormPrintComponent } from './form-print/form-print.component';
import { CashTransactionItemComponent } from './cash-transaction-item/cash-transaction-item.component';
import { ColumnConfigExport } from '../shared/models/config-export.model';

@Component({
  selector: 'app-cash-transaction',
  templateUrl: './cash-transaction.component.html',
  styleUrl: './cash-transaction.component.scss'
})
export class CashTransactionComponent implements OnInit {
  listPaymentMethod: any[] = getListPaymentMethod().filter(r => r.value !== PaymentMethod.Wallet_Voucher && r.value !== PaymentMethod.Wallet);
  tableConfig = [
    { name: 'ticket_no', title: 'cash-transaction.ticket_no', default: null, type: 'textAsLink', sortBy: 'ASC'},
    { name: 'deposit_date', title: 'top-up.date', default: null, type: 'date', sortBy: 'ASC', width: '150px'},
    { name: 'card_no', title: 'card.code', default: null, type: 'text', sortBy: 'ASC', width: '150px' },
    { name: 'card_owner', title: 'service-card.owner', default: null, type: 'text', sortBy: 'ASC', width: '250px' },
    { name: 'payer', title: 'billing.payer', default: null, type: 'text', sortBy: 'ASC', width: '180px' },
    { name: 'payment_method', title: 'payment.type', default: null, type: 'dropdown', options: this.listPaymentMethod, sortBy: 'ASC' },
    { name: 'sum', title: 'cash-transaction.cash', default: null, type: 'number', width: '150px' },
  ];

  filterConfig = [
    { name: 'ticket_no', title: 'cash-transaction.ticket_no', default: '', type: 'text', col: 4 },
    { name: 'card_no', title: 'card.code', default: '', type: 'text', col: 4 },
    { name: 'deposit_date', title: 'top-up.date', default: null, type: 'date-range', col: 4 },
    { name: 'owner', title: 'service-card.owner', default: '', type: 'text', col: 4 },
    { name: 'payment_method', title: 'payment.type', default: [], type: 'multi-select', col: 4, options: this.listPaymentMethod },
    { name: 'deleted', label: 'deleted', default: '', type: 'checkbox', col: 4 },
  ];

  filter: any = {
    limit: 15,
    page: 1,
    sort: '-ticket_no',
    ticket_no: null,
    deposit_date: null,
    owner: null,
    payment_method: null,
    deleted: null
  };

  source: any[] = [];
  totalRows: number = 0;
  @ViewChild('formPrintComponent') formPrintComponent!: FormPrintComponent;
  reOpenDetail = false;

  constructor(
    private service: ProxyDynamicService,
    private modalService: NzModalService,
    private noti: NzNotificationService,
    private translate: TranslateService,
    private datePipe: DatePipe,
    private sharedService: SharedService,
  ) {
  }

  ngOnInit() {
    this.getData();
  }

  getData(event?: any) {
    this.sharedService.showLoading(true);
    if (event) {
      Object.keys(event).forEach((key: any) => {
        this.filter[key] = event[key];
      })
    }

    this.service.getListCashTransaction({
      page: this.filter.page || 1,
      limit: this.filter.limit,
      sortOrder: this.filter.sort.includes('-') ? 'DESC' : 'ASC',
      sortField: this.filter.sort.includes('-') ? this.filter.sort.replace('-', '') : this.filter.sort,
      searchFields: this.filterConfig.map((item: any) => {
        let value;
        if (item.type === 'checkbox' && this.filter[item.name]) {
          value = DeleteStatus.YES;
        } else if (item.type === 'date-range') {
          value = this.filter[item.name]?.map((date: Date) => moment(date).format('YYYY/MM/DD'));
        } else if (item.type === 'multi-select') {
          value = this.filter[item.name]?.length > 0 ? this.filter[item.name] : undefined;
        } else {
          value = this.filter[item.name];
        }

        if (this.filter[item.name]) {
          let obj = {
            field: item.name,
            operator: item.name === 'deposit_date' ? '' : item.name === 'payment_method' ? 'in' : '=',
            value
          }
          return obj;
        }
        return;
      }).filter(r => r && r.value),
    }).subscribe((res: any) => {
      this.totalRows = res.pagination.totalRecords;
      this.source = res?.data
      this.sharedService.showLoading(false);
    }, (error: any) => {
      this.service.handleError(error)
    });
  }

  onChangePage(event: any) {
    this.filter.page = event;
    this.getData();
  }

  onChangeSize(event: any) {
    this.filter.limit = event;
    this.getData();
  }

  onSort(event: any) {
    this.tableConfig.forEach((col) => {
      if (col['name'] === event) {
        this.filter['sort'] = col['sortBy'] === 'ASC' ? event : '-' + event;
        col['sortBy'] = col['sortBy'] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        col['sortBy'] = 'ASC'
      }
    });
    this.getData();
  }

  add() {
    const modalRef = this.modalService.create({
      nzContent: CashTransactionItemComponent,
      nzWidth: '80vw',
      nzClassName: 'modal-cash-transaction',
      nzData: {
        mode: ItemMode.Add,
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '', this.translate.instant('cash-transaction.addCashSuccess'));
        this.getData();
      }
    });
  }

  edit($event: any) {
    const modalRef = this.modalService.create({
      nzContent: CashTransactionItemComponent,
      nzWidth: '80vw',
      nzClassName: 'modal-cash-transaction',
      nzData: {
        mode: ItemMode.Edit,
        listPaymentMethod: this.listPaymentMethod,
        data: $event
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '', this.translate.instant('cash-transaction.updateCashSuccess'));
      }
      this.getData();
    });
  }

  view($event: any) {
    const modalRef = this.modalService.create({
      nzContent: CashTransactionItemComponent,
      nzWidth: '80vw',
      nzClassName: 'modal-cash-transaction',
      nzData: {
        mode: ItemMode.View,
        listPaymentMethod: this.listPaymentMethod,
        data: $event
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '', this.translate.instant('cash-transaction.updateCashSuccess'));
      }
      this.getData();
    });
  }

  delete($event: any) {
    this.service.deleteCashTransaction($event.id).subscribe(res => {
      this.noti.create('success', '', this.translate.instant('billing.deleteSuccess'));
      this.getData();
    }, (error: any) => {
      this.noti.error(error.errors.length ? error.errors[0].message : '', '')
    });
  }

  export() {
    this.service.getListCashTransaction({
      page: 1,
      limit: this.totalRows,
      sortOrder: this.filter.sort.includes('-') ? 'DESC' : 'ASC',
      sortField: this.filter.sort.includes('-') ? this.filter.sort.replace('-', '') : this.filter.sort,
      searchFields: this.filterConfig.map((item: any) => {
        let value;
        if (item.type === 'checkbox' && this.filter[item.name]) {
          value = DeleteStatus.YES;
        } else if (item.type === 'date-range') {
          value = this.filter[item.name]?.map((date: Date) => moment(date).format('YYYY/MM/DD'));
        } else if (item.type === 'multi-select') {
          value = this.filter[item.name]?.length > 0 ? this.filter[item.name] : undefined;
        } else {
          value = this.filter[item.name];
        }

        if (this.filter[item.name]) {
          let obj = {
            field: item.name,
            operator: item.name === 'deposit_date' ? '' : '=',
            value
          }
          return obj;
        }
        return;
      }).filter(r => r && r.value),
    }).subscribe((dataResult: any) => {
      let configColumn: ColumnConfigExport[] = [
        { field: 'ticket_no', headerText: 'cash-transaction.ticket_no', type: 'text' },
        { field: 'deposit_date', headerText: 'top-up.date', type: 'date' },
        { field: 'card_no', headerText: 'card.code', type: 'text' },
        { field: 'card_owner', headerText: 'service-card.owner', type: 'text' },
        { field: 'payer', headerText: 'billing.payer', type: 'text' },
        { field: 'payment_method', headerText: 'payment.type', type: 'dropdown', options: this.listPaymentMethod },
        { field: 'sum', headerText: 'cash-transaction.cash', type: 'number' }
      ];
      const listExport = formatDataExport(dataResult.data, configColumn, this.translate);
      exportAsExcelFile(listExport, this.translate.instant('cash-transaction.title') + '_' + this.datePipe.transform(new Date(), 'yyMMdd'), this.noti, this.translate);
    }, (error: any) => {
      this.service.handleError(error)
    });
  }

  onPrint(event: any, reOpen = false) {
    this.sharedService.showLoading(true);
    this.reOpenDetail = reOpen;
    this.service.findById('cash_transaction', event.id, {
      fields: ['*', 'service_card_id.owner_id.name', 'service_card_id.butler_id.name', 'user_created.first_name', 'user_created.last_name']
    }).then((res: any) => {
      if (res) {
        if (res.service_card_id?.owner_id) {
          res.owner = res.service_card_id.owner_id.name;
        } else if (res.service_card_id?.butler_id) {
          res.owner = res.service_card_id.butler_id.name
        }
      }
      const data = {
        ...event,
        ...res,
        creator: res.user_created ? `${res.user_created.first_name} ${res.user_created.last_name}` : '',
      };
      this.formPrintComponent.data = data;
    });

    this.service.search('cash_transaction_detail',
      {
        fields: ['*.*'],
        filter: {
          'cash_transaction_id': { '_eq': event.id },
          'deleted': { '_eq': DeleteStatus.NO }
        }
      }
    ).then((res) => {
      if (res.length) {
        this.formPrintComponent.listPayment = res.map((item: any) => {
          return {
            card_no: this.formPrintComponent.data?.card_no,
            owner: this.formPrintComponent.data?.owner,
            total_amount: item.total_amount,
            ref_no: this.formPrintComponent.data?.ref_no,
            voucher_no: this.formPrintComponent.data?.voucher_no,
            voucher_amount: this.formPrintComponent.data?.voucher_amount,
            expired_date: this.formPrintComponent.data?.expired_date,
          }
        });
        this.formPrintComponent.totalReceivedAmount = res.reduce((a: number, b: any) => {
          return a + Number(b.total_amount);
        }, 0);
      } else {
        this.formPrintComponent.listPayment = [];
      }
    }, (error: any) => {
      this.service.handleError(error);
    });
    setTimeout(() => {
      this.sharedService.showLoading(false);
      setTimeout(() => {
        window.print()
      }, 500);
    }, 1000);
  }

  @HostListener("window:afterprint", [])
  onAfterPrint() {
    if (this.reOpenDetail) {
      this.view(this.formPrintComponent.data);
    }
  }
}
